// Import all assets
import garam_masala from '../assets/garam masala.jpg';
import chicken_masala from '../assets/chicken masala.jpg';
import mutton_masala from '../assets/mutton masala.jpg';
import biryani_masala from '../assets/biryani.jpg';
import samber_masala from '../assets/samber masala.jpg';
import pav_bhaji_masala from '../assets/pav bhaji masala.jpg';
import veg_mix from '../assets/veg mix.jpg';
import samber_masala1 from '../assets/samber masala1.jpg';
import masala_img from '../assets/masala.jpg';
import dhane_powder1 from '../assets/dhane powder1.jpg';
import dhane_powder from '../assets/dhane powder.jpg';
import chilli_powder1 from '../assets/chilli powder1.jpg';

import curry_masala from '../assets/curry masala.jpg';
import dalchini_powder1 from '../assets/dalchini powder1.jpg';
import curry_masala1 from '../assets/curry masala1.jpg';
import garam_masala2 from '../assets/garam masala2.jpg';
import jire_masala1 from '../assets/jire masala1.jpg';
import masala1 from '../assets/masala1.jpg';
import masala2 from '../assets/masala2.jpg';

import origano from '../assets/origano.jpg';
import chilli_flex from '../assets/chilli flex.jpg';
import kasuri_methi from '../assets/kasuri methi.jpg';
import peri_peri1 from '../assets/peri peri1.jpg';
import kasuri_methi1 from '../assets/kasuri methi1.jpg';

import ginger_garlic from '../assets/ginger garlic.jpg';
import ginger_garlic1 from '../assets/ginger garlic1.jpg';
import kanda_lasun from '../assets/kanda lasun.jpg';
import red_chilli_paste from '../assets/red chilli paste.jpg';
import red_chilli_paste1 from '../assets/red chilli paste1.jpg';

import turmeric1 from '../assets/turmeric1.jpg';
import chilli_powder from '../assets/chilli powder.jpg';
import jire_masala from '../assets/jire masala.jpg';
import black_pepper from '../assets/black pepper.jpg';
import white_pepper from '../assets/white pepper.jpg';
import velachi_powder from '../assets/velachi powder.jpg';
import dalchini_powder from '../assets/dalchini powder.jpg';
import nutmeg_powder1 from '../assets/nutmeg powder1.jpg';
import peri_peri from '../assets/peri peri.jpg';
import ginger_powder from '../assets/ginger powder.jpg';
import chai_masala from '../assets/chai masala.jpg';

import chicken_biryani from '../assets/chicken biryani.jpg';
import mutton_biryani from '../assets/mutton biryani.jpg';
import paneer_tikka from '../assets/paneer tikka.jpg';
import palak_paneer from '../assets/palak paneer.jpg';
import butter_chicken from '../assets/butter chicken.jpg';
import masala3 from '../assets/masala3.jpg';
import veg_biryani from '../assets/veg biryani.jpg';
import veg_kadhai from '../assets/veg kadhai.jpg';
import veg_kolhapuri from '../assets/veg kolhapuri.jpg';
import masala4 from '../assets/masala4.jpg';
import mutter_paneer from '../assets/mutter paneer.jpg';

export const productsData = [
  // SIGNATURE SPICE BLENDS
  {
    id: 'garam-masala',
    name: 'Garam Masala',
    category: 'Signature Spice Blends',
    tagline: 'Authentic Soul of Indian Cooking',
    img: garam_masala,
    price: '₹149',
    description: 'A traditional hand-ground blend of 12 aromatic spices.',
    story: 'Our Garam Masala follows a 50-year-old family recipe, sun-dried and stone-ground to preserve the essential oils.',
    flavor: 'Deeply aromatic with warm, earthy undertones.',
    ingredients: ['Black Cardamom', 'Cloves', 'Cinnamon', 'Black Pepper', 'Cumin Seeds'],
    usage: 'Perfect for all North Indian curries, dal, and dry vegetable preparations.',
    color: '#D35400'
  },
  {
    id: 'chicken-masala',
    name: 'Chicken Masala',
    category: 'Signature Spice Blends',
    tagline: 'Dhaba Style Chicken at Home',
    img: chicken_masala,
    price: '₹169',
    description: 'A robust blend designed to bring out the juicy flavors of poultry.',
    story: 'Crafted for meat lovers who crave that perfect rustic Dhaba taste.',
    flavor: 'Spicy, rich, and intensely savory.',
    ingredients: ['Dry Ginger', 'Garlic', 'Star Anise', 'Coriander', 'Red Chilli'],
    usage: 'Ideal for Chicken Curry, Chicken Sukka, and spicy gravies.',
    color: '#E67E22'
  },
  {
    id: 'mutton-masala',
    name: 'Mutton Masala',
    category: 'Signature Spice Blends',
    tagline: 'Royal Taste for Slow-Cooked Meat',
    img: mutton_masala,
    price: '₹189',
    description: 'Intense spices for deep, red mutton gravies.',
    story: 'Slow-roasted spices that break down during the long cooking process of red meat.',
    flavor: 'Smoky, bold, and extra spicy.',
    ingredients: ['Mace', 'Nutmeg', 'Bay Leaf', 'Kashmiri Chilli', 'Poppy Seeds'],
    usage: 'Best for Mutton Curry, Lamb Chops, and rich meat stews.',
    color: '#C0392B'
  },
  {
    id: 'biryani-masala',
    name: 'Biryani Masala',
    category: 'Signature Spice Blends',
    tagline: 'Celebration in Every Grain',
    img: biryani_masala,
    price: '₹199',
    description: 'Fragrant blend for authentic Hyderabadi and Lucknowi Biryani.',
    story: 'A secret mixture of shahi spices to make your rice dishes royal.',
    flavor: 'Majestic floral notes with a hint of sweetness.',
    ingredients: ['Shahi Jeera', 'Mace', 'Saffron Strands', 'Green Cardamom'],
    usage: 'Essential for Dum Biryani, Pulao, and Nawabi Rice.',
    color: '#8E44AD'
  },
  {
    id: 'chole-masala',
    name: 'Chole Masala',
    category: 'Signature Spice Blends',
    tagline: 'Amritsari Magic',
    img: samber_masala, // User asked for samber masala image here
    price: '₹139',
    description: 'Tangy and robust blend for dark, spicy chickpeas.',
    story: 'Inspired by the legendary dhabas of Amritsar.',
    flavor: 'Savory and slightly tangy with pomegranate seeds.',
    ingredients: ['Dried Mango', 'Anardana', 'Ginger', 'Black Salt'],
    usage: 'Specifically for Chole Bhature and Pindi Chole.',
    color: '#1A1208'
  },
  {
    id: 'pav-bhaji-masala',
    name: 'Pav Bhaji Masala',
    category: 'Signature Spice Blends',
    tagline: 'Mumbai Street Style Heart',
    img: pav_bhaji_masala,
    price: '₹129',
    description: 'The secret to the perfect buttery Pav Bhaji mash.',
    story: 'Born on the beaches of Juhu, this blend is pure nostalgia.',
    flavor: 'Buttery, tangy, and medium spicy.',
    ingredients: ['Dry Mango', 'Cumin', 'Fennel Seeds', 'Black Salt'],
    usage: 'Must-have for Pav Bhaji, Tawa Pulao, and Masala Pav.',
    color: '#D4700A'
  },
  {
    id: 'kitchen-king',
    name: 'Kitchen King Masala',
    category: 'Signature Spice Blends',
    tagline: 'The Master of All Curries',
    img: veg_mix,
    price: '₹159',
    description: 'The ultimate all-rounder for any vegetable dish.',
    story: 'The one-spice solution for every kitchen dilemma.',
    flavor: 'Balanced, savory, and multi-dimensional.',
    ingredients: ['Coriander', 'Turmeric', 'Cumin', 'Fenugreek'],
    usage: 'Add to any veg curry, dry sabji, or even dal tadka.',
    color: '#27AE60'
  },
  {
    id: 'sabji-masala',
    name: 'Sabji Masala',
    category: 'Signature Spice Blends',
    tagline: 'Daily Veggie Delight',
    img: samber_masala1,
    price: '₹119',
    description: 'Enhances the natural taste of daily seasonal vegetables.',
    story: 'A light blend designed for everyday healthy cooking.',
    flavor: 'Mildly spicy and earthy.',
    ingredients: ['Coriander', 'Turmeric', 'Cumin', 'Black Pepper'],
    usage: 'Ideal for Aloo Gobi, Bhindi Fry, and Mixed Veg.',
    color: '#F39C12'
  },
  {
    id: 'fish-fry-masala',
    name: 'Fish Fry Masala',
    category: 'Signature Spice Blends',
    tagline: 'Coastal Crisp Perfection',
    img: masala_img,
    price: '₹179',
    description: 'Traditional Konkani blend for crispy fried fish.',
    story: 'Sourced from the shores of Malvan.',
    flavor: 'Tangy, spicy, and perfectly salted.',
    ingredients: ['Triphala', 'Red Chilli', 'Turmeric', 'Asafoetida'],
    usage: 'Best for Pomfret Fry, Surmai, and Prawns Koliwada.',
    color: '#E74C3C'
  },
  {
    id: 'tandoori-masala',
    name: 'Tandoori Masala',
    category: 'Signature Spice Blends',
    tagline: 'The Smoky Red Glow',
    img: dhane_powder1,
    price: '₹169',
    description: 'Gives that perfect smoky aroma and red color to grills.',
    story: 'Crafted for clay oven cooking, but works wonders on pans.',
    flavor: 'Smoky, citrusy, and bold.',
    ingredients: ['Kashmiri Chilli', 'Nutmeg', 'Mace', 'Dry Garlic'],
    usage: 'Perfect for Paneer Tikka, Tandoori Chicken, and Soya Chaap.',
    color: '#C0392B'
  },
  {
    id: 'misal-masala',
    name: 'Misal Masala',
    category: 'Signature Spice Blends',
    tagline: 'The Ultimate Maharashtrian Kick',
    img: dhane_powder,
    price: '₹149',
    description: 'Sharp, spicy blend for the iconic Misal Rassa.',
    story: 'Directly from the spicy heart of Nashik.',
    flavor: 'Pungent, extra spicy, and sharp.',
    ingredients: ['Lavangi Chilli', 'Black Pepper', 'Cloves', 'Star Anise'],
    usage: 'Exclusively for Misal Pav and Kat (Spicy Oil).',
    color: '#D63031'
  },
  {
    id: 'kolhapuri-masala',
    name: 'Kolhapuri Masala',
    category: 'Signature Spice Blends',
    tagline: 'Bold, Fiery, Authentic',
    img: chilli_powder1,
    price: '₹159',
    description: 'The famous Kanda-Lasun based fiery blend.',
    story: 'A tribute to the wrestlers and spice-lovers of Kolhapur.',
    flavor: 'Extremely spicy with a rich garlic undertone.',
    ingredients: ['Red Chilli', 'Garlic', 'Onion', 'Dry Coconut'],
    usage: 'Perfect for Tambada Rassa, Veg Kolhapuri, and Shev Bhaji.',
    color: '#960000'
  },

  // CHEF’S READY MIX
  {
    id: 'instant-gravy-mix',
    name: 'Instant Gravy Mix',
    category: 'Chef’s Ready Mix',
    tagline: 'Restaurant Quality in 5 Minutes',
    img: curry_masala,
    price: '₹249',
    description: 'Just add water and veggies/meat for a rich gravy.',
    story: 'The shortcut to culinary greatness.',
    flavor: 'Creamy and rich.',
    ingredients: ['Cashew Powder', 'Tomato Solids', 'Dairy Whitener'],
    usage: 'Base for Paneer Butter Masala or Malai Kofta.',
    color: '#F39C12'
  },
  {
    id: 'ready-biryani-mix',
    name: 'Ready Biryani Mix',
    category: 'Chef’s Ready Mix',
    tagline: 'Zero Effort, Maximum Aroma',
    img: dalchini_powder1,
    price: '₹299',
    description: 'A pre-blended mix including whole spices and masala.',
    story: 'For those who want Biryani without the hard work.',
    flavor: 'Highly aromatic and saffron-heavy.',
    ingredients: ['Whole Spices', 'Fried Onions', 'Biryani Essence'],
    usage: 'Add to soaked rice and cooked meat for instant Dum Biryani.',
    color: '#8E44AD'
  },
  {
    id: 'curry-base-mix',
    name: 'Curry Base Mix',
    category: 'Chef’s Ready Mix',
    tagline: 'Universal Curry Secret',
    img: curry_masala1,
    price: '₹229',
    description: 'A versatile powder that turns into a thick sauce.',
    story: 'Designed for the modern professional kitchen.',
    flavor: 'Savory and slightly sweet.',
    ingredients: ['Onion Flakes', 'Garlic Powder', 'Starch', 'Spices'],
    usage: 'Base for any Indian curry or stew.',
    color: '#D4700A'
  },
  {
    id: 'ready-paneer-masala',
    name: 'Ready Paneer Masala',
    category: 'Chef’s Ready Mix',
    tagline: 'Soft Paneer, Sharp Flavor',
    img: garam_masala2,
    price: '₹199',
    description: 'Complete mix for Shahi and Kadai Paneer.',
    story: 'Brings the North Indian dhaba feel to your home.',
    flavor: 'Spicy and creamy.',
    ingredients: ['Melon Seeds', 'Spices', 'Dried Cream'],
    usage: 'Just add Paneer cubes and simmer.',
    color: '#E67E22'
  },
  {
    id: 'ready-dal-tadka',
    name: 'Ready Dal Tadka Mix',
    category: 'Chef’s Ready Mix',
    tagline: 'The Golden Comfort',
    img: jire_masala1,
    price: '₹179',
    description: 'Complete seasoning for your boiled lentils.',
    story: 'The taste of home-cooked comfort in an instant.',
    flavor: 'Garlicky and cumin-forward.',
    ingredients: ['Roasted Cumin', 'Garlic', 'Green Chilli Powder'],
    usage: 'Toss into boiled Tuvar or Moong Dal.',
    color: '#F1C40F'
  },
  {
    id: 'quick-curry-paste',
    name: 'Quick Curry Paste',
    category: 'Chef’s Ready Mix',
    tagline: 'Squeeze the Flavor',
    img: masala1,
    price: '₹219',
    description: 'A thick, oil-based paste for instant cooking.',
    story: 'Cold-pressed spices in an artisanal paste.',
    flavor: 'Tangy and spicy.',
    ingredients: ['Oil', 'Ginger', 'Garlic', 'Red Chilli'],
    usage: 'Add to the pan for an instant flavor base.',
    color: '#E74C3C'
  },
  {
    id: 'instant-marinade',
    name: 'Instant Marinade Mix',
    category: 'Chef’s Ready Mix',
    tagline: 'Perfect Tenders Every Time',
    img: masala2,
    price: '₹239',
    description: 'Pre-salt and spice mix for marinating meats.',
    story: 'The science of tenderizing meat with spices.',
    flavor: 'Citrusy and savory.',
    ingredients: ['Papain', 'Black Salt', 'Lemon Powder'],
    usage: 'Rub on chicken or mutton before grilling/frying.',
    color: '#C0392B'
  },

  // LUXURY SPICE RANGE
  {
    id: 'oregano',
    name: 'Oregano',
    category: 'Luxury Spice Range',
    tagline: 'Mediterranean Freshness',
    img: origano,
    price: '₹129',
    description: 'Highest grade dried oregano leaves.',
    story: 'Sourced from the sun-drenched hills of the Mediterranean.',
    flavor: 'Pungent, earthy, and green.',
    ingredients: ['100% Dried Oregano Leaves'],
    usage: 'Perfect for Pizzas, Pasta, and Garlic Bread.',
    color: '#27AE60'
  },
  {
    id: 'chili-flakes',
    name: 'Chili Flakes',
    category: 'Luxury Spice Range',
    tagline: 'The Perfect Pizza Partner',
    img: chilli_flex,
    price: '₹119',
    description: 'Coarse ground dried red chilies with seeds.',
    story: 'For that extra punch in every bite.',
    flavor: 'Sharp heat and crunchy texture.',
    ingredients: ['Dried Red Chilli Flakes'],
    usage: 'Sprinkle on everything from pizza to avocado toast.',
    color: '#E74C3C'
  },
  {
    id: 'mixed-herbs',
    name: 'Mixed Herbs',
    category: 'Luxury Spice Range',
    tagline: 'Boutique Blend of Greens',
    img: kasuri_methi, // User asked for kasuri methi image here
    price: '₹149',
    description: 'A blend of basil, thyme, rosemary, and oregano.',
    story: 'The ultimate seasoning for continental dishes.',
    flavor: 'Herbal and aromatic.',
    ingredients: ['Thyme', 'Basil', 'Rosemary', 'Oregano'],
    usage: 'Elevates soups, salads, and grilled meats.',
    color: '#2ECC71'
  },
  {
    id: 'peri-peri-mix',
    name: 'Peri Peri Mix',
    category: 'Luxury Spice Range',
    tagline: 'African Bird’s Eye Heat',
    img: peri_peri1,
    price: '₹159',
    description: 'A spicy, tangy African-inspired seasoning.',
    story: 'Crafted for the global palate.',
    flavor: 'Extremely spicy, citrusy, and savory.',
    ingredients: ['Bird’s Eye Chilli', 'Garlic', 'Onion Powder', 'Citric Acid'],
    usage: 'Sprinkle on fries, popcorn, or grilled corn.',
    color: '#D63031'
  },
  {
    id: 'kasuri-hot-mix',
    name: 'Kasuri Hot Mix',
    category: 'Luxury Spice Range',
    tagline: 'Aromatic Heat',
    img: kasuri_methi1,
    price: '₹139',
    description: 'Premium Kasuri Methi with a spicy twist.',
    story: 'Dried in the shade to retain maximum aroma.',
    flavor: 'Bitter-sweet and spicy.',
    ingredients: ['Dried Fenugreek Leaves', 'Red Chilli Powder'],
    usage: 'Garnish for Butter Chicken or Paneer dishes.',
    color: '#15B01A'
  },

  // RICH MASALA PASTES
  {
    id: 'ginger-garlic-paste',
    name: 'Ginger Garlic Paste',
    category: 'Rich Masala Pastes',
    tagline: 'The Essential Foundation',
    img: ginger_garlic,
    price: '₹89',
    description: 'Freshly crushed ginger and garlic.',
    story: 'No more peeling, no more grinding.',
    flavor: 'Pungent and fresh.',
    ingredients: ['Fresh Ginger', 'Garlic', 'Salt'],
    usage: 'The base for 90% of Indian curries.',
    color: '#F1C40F'
  },
  {
    id: 'garlic-paste',
    name: 'Garlic Paste',
    category: 'Rich Masala Pastes',
    tagline: 'Pure Garlic Power',
    img: ginger_garlic1,
    price: '₹79',
    description: 'Smooth and aromatic garlic puree.',
    story: 'Made from hand-peeled cloves.',
    flavor: 'Sharp and savory.',
    ingredients: ['Pure Garlic', 'Vinegar'],
    usage: 'Use in marinades, soups, and Chinese dishes.',
    color: '#BDC3C7'
  },
  {
    id: 'onion-garlic-paste',
    name: 'Onion Garlic Paste',
    category: 'Rich Masala Pastes',
    tagline: 'The Gravy Thickener',
    img: kanda_lasun,
    price: '₹99',
    description: 'Roasted onions and garlic in a smooth paste.',
    story: 'Brings restaurant-like thickness to home cooking.',
    flavor: 'Sweet and savory.',
    ingredients: ['Onion', 'Garlic', 'Sunflower Oil'],
    usage: 'Instant base for thick Indian gravies.',
    color: '#D4700A'
  },
  {
    id: 'red-chilli-paste',
    name: 'Red Chilli Paste',
    category: 'Rich Masala Pastes',
    tagline: 'Vibrant Heat',
    img: red_chilli_paste,
    price: '₹109',
    description: 'Deseeded and soaked red chilli paste.',
    story: 'The secret to that beautiful bright red color.',
    flavor: 'Fiery and tangy.',
    ingredients: ['Sun-dried Red Chilli', 'Vinegar'],
    usage: 'Use for Schezwan sauce or Rogan Josh.',
    color: '#C0392B'
  },
  {
    id: 't-curry-paste',
    name: 'TCurry Paste',
    category: 'Rich Masala Pastes',
    tagline: 'Instant Spice Base',
    img: red_chilli_paste1,
    price: '₹129',
    description: 'A concentrated mix of 15 spices in oil.',
    story: 'For the ultimate authentic curry.',
    flavor: 'Complex and spicy.',
    ingredients: ['Oil', 'Whole Spices', 'Chilli Paste'],
    usage: 'Sauté with onions for a quick gourmet meal.',
    color: '#960000'
  },

  // FARM FRESH SPICES
  {
    id: 'turmeric-powder',
    name: 'Turmeric Powder',
    category: 'Farm Fresh Spices',
    tagline: 'The Golden Healer',
    img: turmeric1,
    price: '₹99',
    description: 'High curcumin turmeric sourced from Meghalaya.',
    story: 'Known for its medicinal and culinary properties.',
    flavor: 'Earthy and warm.',
    ingredients: ['100% Pure Turmeric'],
    usage: 'In curries, milk, and immunity shots.',
    color: '#F1C40F'
  },
  {
    id: 'red-chilli-powder',
    name: 'Red Chilli Powder',
    category: 'Farm Fresh Spices',
    tagline: 'Vibrant Red Passion',
    img: chilli_powder,
    price: '₹119',
    description: 'Spicy blend of Guntur and Resham chilli.',
    story: 'Hand-picked chillies, sun-dried to perfection.',
    flavor: 'Extremely hot and colorful.',
    ingredients: ['Dried Red Chilli'],
    usage: 'Perfect for seasoning and color.',
    color: '#E74C3C'
  },
  {
    id: 'coriander-powder',
    name: 'Coriander Powder',
    category: 'Farm Fresh Spices',
    tagline: 'Aromatic Earthiness',
    img: dhane_powder,
    price: '₹89',
    description: 'Cold-ground coriander seeds.',
    story: 'Sourced from the best farms of Rajasthan.',
    flavor: 'Light, sweet, and nutty.',
    ingredients: ['Roasted Coriander Seeds'],
    usage: 'The volume-giver to every Indian gravy.',
    color: '#27AE60'
  },
  {
    id: 'jeera-powder',
    name: 'Jeera Powder',
    category: 'Farm Fresh Spices',
    tagline: 'Roasted Perfection',
    img: jire_masala,
    price: '₹129',
    description: 'Freshly roasted and ground cumin seeds.',
    story: 'The quintessential Indian seasoning.',
    flavor: 'Warm, earthy, and aromatic.',
    ingredients: ['100% Cumin Seeds'],
    usage: 'Sprinkle on curd, buttermilk, or add to curries.',
    color: '#D35400'
  },
  {
    id: 'black-pepper',
    name: 'Black Pepper',
    category: 'Farm Fresh Spices',
    tagline: 'The King of Spices',
    img: black_pepper,
    price: '₹199',
    description: 'Premium Malabar black pepper pods ground to powder.',
    story: 'Sourced from the coastal spice gardens.',
    flavor: 'Sharp, spicy, and woody.',
    ingredients: ['Pure Black Pepper'],
    usage: 'Seasoning for soups, salads, and non-veg dishes.',
    color: '#34495E'
  },
  {
    id: 'white-pepper',
    name: 'White Pepper',
    category: 'Farm Fresh Spices',
    tagline: 'Subtle Heat',
    img: white_pepper,
    price: '₹219',
    description: 'Milder and lighter alternative to black pepper.',
    story: 'Husked pepper for refined white sauces.',
    flavor: 'Sharp but less complex than black pepper.',
    ingredients: ['Husked White Pepper'],
    usage: 'Used in white gravies, soups, and Chinese food.',
    color: '#ECF0F1'
  },
  {
    id: 'cardamom',
    name: 'Cardamom',
    category: 'Farm Fresh Spices',
    tagline: 'Queen of Fragrance',
    img: velachi_powder,
    price: '₹499',
    description: 'Premium green cardamom pods ground into fine powder.',
    story: 'Hand-plucked from the high-altitude plantations.',
    flavor: 'Sweet, floral, and intensely aromatic.',
    ingredients: ['Green Cardamom'],
    usage: 'In tea, sweets, and biryanis.',
    color: '#2ECC71'
  },
  {
    id: 'cinnamon',
    name: 'Cinnamon',
    category: 'Farm Fresh Spices',
    tagline: 'The Sweet Bark',
    img: dalchini_powder,
    price: '₹149',
    description: 'High-grade Ceylon cinnamon powder.',
    story: 'Ancient spice used for its woody sweetness.',
    flavor: 'Sweet, woody, and warm.',
    ingredients: ['Pure Cinnamon Bark'],
    usage: 'In baking, tea, and meat marinades.',
    color: '#7E5109'
  },
  {
    id: 'nutmeg-powder',
    name: 'Nutmeg Powder',
    category: 'Farm Fresh Spices',
    tagline: 'Exotic Warmth',
    img: nutmeg_powder1,
    price: '₹189',
    description: 'Freshly ground nutmeg nut.',
    story: 'A little goes a long way with this exotic spice.',
    flavor: 'Sweet, nutty, and highly aromatic.',
    ingredients: ['Pure Nutmeg'],
    usage: 'Garnish for desserts and creamy sauces.',
    color: '#A04000'
  },
  {
    id: 'kashmiri-chilli',
    name: 'Kashmiri Chilli',
    category: 'Farm Fresh Spices',
    tagline: 'Vibrant Color, Low Heat',
    img: peri_peri, // User asked for peri peri image here
    price: '₹179',
    description: 'Famous for its deep red color and mild heat.',
    story: 'Sourced from the valleys of Kashmir.',
    flavor: 'Fruity and mildly spicy.',
    ingredients: ['Kashmiri Red Chilli'],
    usage: 'Used for Rogan Josh and color in gravies.',
    color: '#960000'
  },
  {
    id: 'dry-ginger-powder',
    name: 'Dry Ginger Powder',
    category: 'Farm Fresh Spices',
    tagline: 'Zesty Vitality',
    img: ginger_powder,
    price: '₹129',
    description: 'Sun-dried ginger ground to a fine powder.',
    story: 'A traditional household remedy and spice.',
    flavor: 'Sharp and zesty.',
    ingredients: ['Sun-dried Ginger'],
    usage: 'In tea, ginger snaps, and dry curries.',
    color: '#F4D03F'
  },
  {
    id: 'chai-masala',
    name: 'Chai Masala',
    category: 'Farm Fresh Spices',
    tagline: 'Morning Ritual Essential',
    img: chai_masala,
    price: '₹139',
    description: 'A blend of cardamom, ginger, and cinnamon for tea.',
    story: 'Makes every cup of tea a celebration.',
    flavor: 'Zesty and fragrant.',
    ingredients: ['Cardamom', 'Ginger', 'Cinnamon', 'Cloves'],
    usage: 'Add a pinch to boiling tea.',
    color: '#7E5109'
  },

  // WORLD SPICE SERIES
  {
    id: 'royal-chicken-masala',
    name: 'Royal Chicken Masala',
    category: 'World Spice Series',
    tagline: 'Grandeur in Every Bite',
    img: chicken_masala,
    price: '₹229',
    description: 'A regal blend for Mughlai-style chicken dishes.',
    story: 'Designed for the royal kitchens.',
    flavor: 'Rich, creamy, and mildly spicy.',
    ingredients: ['Cashew Powder', 'Kesar', 'Premium Spices'],
    usage: 'Ideal for Chicken Korma and Shahi Roast.',
    color: '#D4700A'
  },
  {
    id: 'shahi-mutton-masala',
    name: 'Shahi Mutton Masala',
    category: 'World Spice Series',
    tagline: 'The Nawab’s Secret',
    img: mutton_masala,
    price: '₹249',
    description: 'Luxury blend for slow-cooked mutton.',
    story: 'Heritage recipe from Awadh.',
    flavor: 'Intense and majestic.',
    ingredients: ['Mace', 'Black Cumin', 'White Pepper'],
    usage: 'Best for Mutton Nihari and Galauti Kebabs.',
    color: '#641E16'
  },
  {
    id: 'dum-biryani-masala',
    name: 'Dum Biryani Special Masala',
    category: 'World Spice Series',
    tagline: 'The Aroma of Perfection',
    img: chicken_biryani,
    price: '₹269',
    description: 'Specialty mix for long-grained Basmati Biryanis.',
    story: 'Engineered for slow-steam cooking.',
    flavor: 'Highly aromatic.',
    ingredients: ['Whole Spices', 'Kewra Essence Powder'],
    usage: 'Essential for Dum Biryani.',
    color: '#8E44AD'
  },
  {
    id: 'nawabi-mutton-biryani',
    name: 'Nawabi Mutton Biryani Masala',
    category: 'World Spice Series',
    tagline: 'Richness Redefined',
    img: mutton_biryani,
    price: '₹289',
    description: 'Premium blend for the ultimate meat biryani.',
    story: 'Inspired by the courts of Lucknow.',
    flavor: 'Smoky and rich.',
    ingredients: ['Saffron', 'Black Cardamom', 'Cloves'],
    usage: 'Specifically for Nawabi Mutton Biryani.',
    color: '#5B2C6F'
  },
  {
    id: 'mumbai-pav-bhaji',
    name: 'Mumbai Style Pav Bhaji Masala',
    category: 'World Spice Series',
    tagline: 'Street Food Legend',
    img: pav_bhaji_masala,
    price: '₹189',
    description: 'Extra tangy and spicy for that authentic Juhu taste.',
    story: 'The original recipe from Mumbai’s streets.',
    flavor: 'Tangy and spicy.',
    ingredients: ['Dry Mango', 'Black Salt', 'Red Chilli'],
    usage: 'Perfect for Mumbai Style Pav Bhaji.',
    color: '#E67E22'
  },
  {
    id: 'classic-paneer-masala',
    name: 'Classic Paneer Masala',
    category: 'World Spice Series',
    tagline: 'Golden Paneer Curry',
    img: paneer_tikka,
    price: '₹199',
    description: 'Traditional blend for cottage cheese curries.',
    story: 'The comfort of home-cooked paneer.',
    flavor: 'Creamy and earthy.',
    ingredients: ['Turmeric', 'Coriander', 'Melon Seeds'],
    usage: 'Ideal for Paneer Tikka Masala.',
    color: '#F39C12'
  },
  {
    id: 'creamy-palak-paneer',
    name: 'Creamy Palak Paneer Masala',
    category: 'World Spice Series',
    tagline: 'Vibrant Green Taste',
    img: palak_paneer,
    price: '₹179',
    description: 'Designed to preserve the green of spinach while adding heat.',
    story: 'A healthy and spicy classic.',
    flavor: 'Fresh and herbal.',
    ingredients: ['Green Chilli Powder', 'Dry Ginger', 'Garlic'],
    usage: 'Exclusively for Palak Paneer.',
    color: '#27AE60'
  },
  {
    id: 'delhi-butter-chicken',
    name: 'Delhi Style Butter Chicken Masala',
    category: 'World Spice Series',
    tagline: 'Capital’s Pride',
    img: butter_chicken,
    price: '₹219',
    description: 'Sweet and spicy blend for the ultimate butter chicken.',
    story: 'From the heart of Old Delhi.',
    flavor: 'Sweet, tangy, and creamy.',
    ingredients: ['Tomato Powder', 'Kasuri Methi', 'Honey Powder'],
    usage: 'Perfect for Butter Chicken and Dal Makhani.',
    color: '#D35400'
  },
  {
    id: 'mughlai-butter-chicken',
    name: 'Mughlai Butter Chicken Biryani Masala',
    category: 'World Spice Series',
    tagline: 'Fusion of Royalty',
    img: masala3,
    price: '₹259',
    description: 'A unique blend for butter chicken infused biryani.',
    story: 'The best of two worlds.',
    flavor: 'Creamy and aromatic.',
    ingredients: ['Cream Powder', 'Mughlai Spices'],
    usage: 'Specifically for Butter Chicken Biryani.',
    color: '#A04000'
  },
  {
    id: 'aroma-veg-pulav',
    name: 'Aroma Veg Pulav Masala',
    category: 'World Spice Series',
    tagline: 'Garden in Your Plate',
    img: veg_biryani,
    price: '₹169',
    description: 'Light and fragrant blend for rice and vegetables.',
    story: 'The scent of a fresh harvest.',
    flavor: 'Mild and floral.',
    ingredients: ['Green Cardamom', 'Bay Leaf', 'Cinnamon'],
    usage: 'Best for Veg Pulav and Fried Rice.',
    color: '#2ECC71'
  },
  {
    id: 'royal-veg-biryani',
    name: 'Royal Veg Biryani Masala',
    category: 'World Spice Series',
    tagline: 'The Veg King',
    img: veg_kadhai,
    price: '₹199',
    description: 'Robust spices for a meat-like intensity in veg biryani.',
    story: 'Who said veg can’t be royal?',
    flavor: 'Bold and spicy.',
    ingredients: ['Black Stone Flower', 'Nutmeg', 'Mace'],
    usage: 'Ideal for Royal Veg Biryani.',
    color: '#229954'
  },
  {
    id: 'kolhapuri-misal',
    name: 'Kolhapuri Misal Special Masala',
    category: 'World Spice Series',
    tagline: 'The Ultimate Challenge',
    img: veg_kolhapuri,
    price: '₹179',
    description: 'Extreme heat for the brave misal lovers.',
    story: 'The spiciest corner of Maharashtra.',
    flavor: 'Fiery and pungent.',
    ingredients: ['Nagkesar', 'Lavangi Chilli', 'Garlic'],
    usage: 'For authentic Kolhapuri Misal.',
    color: '#900C3F'
  },
  {
    id: 'coastal-fish-fry',
    name: 'Coastal Fish Fry Masala',
    category: 'World Spice Series',
    tagline: 'Ocean in Your Kitchen',
    img: veg_mix, // User asked for veg mix image here
    price: '₹209',
    description: 'Spicy and sour blend for coastal seafood.',
    story: 'The salt of the Konkan coast.',
    flavor: 'Sour and hot.',
    ingredients: ['Kokum Powder', 'Red Chilli', 'Turmeric'],
    usage: 'Perfect for Coastal Fish Fry.',
    color: '#1F618D'
  },
  {
    id: 'smoky-tandoori-chicken',
    name: 'Smoky Tandoori Chicken Masala',
    category: 'World Spice Series',
    tagline: 'Charred Perfection',
    img: masala4,
    price: '₹239',
    description: 'High intensity smoky aroma without the charcoal.',
    story: 'The essence of a clay oven in a box.',
    flavor: 'Smoky and salty.',
    ingredients: ['Natural Smoke Flavor', 'Spices', 'Salt'],
    usage: 'For Smoky Tandoori Chicken.',
    color: '#641E16'
  },
  {
    id: 'desi-mutter-paneer',
    name: 'Desi mutter Paneer',
    category: 'World Spice Series',
    tagline: 'The Village Flavor',
    img: mutter_paneer,
    price: '₹189',
    description: 'Simple yet profound blend for peas and cottage cheese.',
    story: 'Traditional village-style recipe.',
    flavor: 'Sweet and earthy.',
    ingredients: ['Coriander Seeds', 'Turmeric', 'Cumin'],
    usage: 'Exclusively for Mutter Paneer.',
    color: '#D4AC0D'
  }
];
